import { render, staticRenderFns } from "./MoneyNavigation.vue?vue&type=template&id=494a16a0&"
import script from "./MoneyNavigation.vue?vue&type=script&lang=js&"
export * from "./MoneyNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports